import React, { useState, useEffect } from 'react';
import './surveillanceComplet.css';
import Administration from './administration';
import { FaEllipsisV } from "react-icons/fa";
import { FaFolder } from "react-icons/fa";
import { FaBed } from "react-icons/fa6";
import Select from 'react-select';
import api from '../../service/caller';
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';

// FRAME 05 – Surveillance medical complet (modified)
function SuiviMedicalComplet({ onNext, onBack, updatePatientDossier, patientId }) {
    const [surveillanceQuotidienne, setCheckins] = useState([]);
    useEffect (() => {
        const fetchCheckins = async () => {
            try {
              const response = await api.get(`api/treatment-plans/checkins/${patientId._id}`);
              setCheckins(response.data.data);
            } catch (error) {
              console.error("Failed to fetch user data", error);
            }
          };
          
          fetchCheckins();
    }, []);
    // Fonction pour basculer l'affichage des détails d'une entrée
    const toggleDetails = (id) => {
    setExpandedId(expandedId === id ? null : id);
    };
    const [expandedId, setExpandedId] = useState(null);
    // Fonction pour formater la date et l'heure
    const formatDate = (dateString, format) => {
    const date = new Date(dateString);
    if (format === "HH:mm") {
      return date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
    } else if (format === "yyyy-MM-dd") {
      return date.toLocaleDateString('fr-FR', { year: 'numeric', month: '2-digit', day: '2-digit' }).split('/').reverse().join('-');
    }
    return dateString;
    };
  return (
    <div className="suivi-med-frame">
      <h1 className="suivi-med-header">Suivi Médical Complet</h1>
      
      {/* Version desktop */}
      <div className="suivi-med-desktop">
        <table className="suivi-med-table">
          <thead>
            <tr>
              <th>ID Admission</th>
              <th>Blood Pressure</th>
              <th>Temperature</th>
              <th>Heart Rate</th>
              <th>Respiration Rate</th>
              <th>Observation</th>
              <th>Time</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {surveillanceQuotidienne && surveillanceQuotidienne.length > 0 ? (
              surveillanceQuotidienne.map(entry => (
                <tr key={entry.admissionId}>
                  <td>{entry.admissionId}</td>
                  <td>{entry.vitalSigns.bloodPressure} mmHg</td>
                  <td>{entry.vitalSigns.temperature} °C</td>
                  <td>{entry.vitalSigns.heartRate} bpm</td>
                  <td>{entry.vitalSigns.respirationRate} breaths/min</td>
                  <td>{entry.observations}</td>
                  <td>{formatDate(entry.date, "HH:mm")}</td>
                  <td>{formatDate(entry.date, "yyyy-MM-dd")}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="suivi-med-empty">
                  Aucune donnée enregistrée
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      
      {/* Version mobile */}
      <div className="suivi-med-mobile">
        {surveillanceQuotidienne && surveillanceQuotidienne.length > 0 ? (
          surveillanceQuotidienne.map(entry => (
            <div key={entry.admissionId} className="suivi-med-card">
              <div 
                className="suivi-med-card-header"
                onClick={() => toggleDetails(entry.admissionId)}
              >
                <div className="suivi-med-card-title">
                  <span>ID: {entry.admissionId}</span>
                  <span className="suivi-med-card-date">{formatDate(entry.date, "yyyy-MM-dd")}</span>
                </div>
                <span className="suivi-med-expand-icon">
                  {expandedId === entry.admissionId ? '▼' : '►'}
                </span>
              </div>
              
              {expandedId === entry.admissionId && (
                <div className="suivi-med-card-content">
                  <div className="suivi-med-data-row">
                    <span className="suivi-med-label">Blood Pressure:</span>
                    <span className="suivi-med-value">{entry.vitalSigns.bloodPressure} mmHg</span>
                  </div>
                  <div className="suivi-med-data-row">
                    <span className="suivi-med-label">Temperature:</span>
                    <span className="suivi-med-value">{entry.vitalSigns.temperature} °C</span>
                  </div>
                  <div className="suivi-med-data-row">
                    <span className="suivi-med-label">Heart Rate:</span>
                    <span className="suivi-med-value">{entry.vitalSigns.heartRate} bpm</span>
                  </div>
                  <div className="suivi-med-data-row">
                    <span className="suivi-med-label">Respiration Rate:</span>
                    <span className="suivi-med-value">{entry.vitalSigns.respirationRate} breaths/min</span>
                  </div>
                  <div className="suivi-med-data-row">
                    <span className="suivi-med-label">Time:</span>
                    <span className="suivi-med-value">{formatDate(entry.date, "HH:mm")}</span>
                  </div>
                  <div className="suivi-med-data-row suivi-med-observation">
                    <span className="suivi-med-label">Observation:</span>
                    <span className="suivi-med-value">{entry.observations}</span>
                  </div>
                </div>
              )}
            </div>
          ))
        ) : (
          <div className="suivi-med-empty-mobile">
            Aucune donnée enregistrée
          </div>
        )}
      </div>
      
      <div className="suivi-med-actions">
        <button
          className="suivi-med-btn suivi-med-btn-primary"
          onClick={() => onNext(6)}
        >
          Consulter le paiement
        </button>
        {onBack && (
          <button 
            className="suivi-med-btn suivi-med-btn-secondary"
            onClick={() => onNext(1)}
          >
            Retour
          </button>
        )}
      </div>
    </div>
  );
}

export default SuiviMedicalComplet;